import { z } from "zod";

// Base schema for fields common to both create and update
const baseUserSchema = {
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  user_type_id: z.number().min(1, "User type is required"),
  role_id: z.number().min(1, "User role is required"),
  location_id: z.number().min(1, "Location is required"),
  date_of_birth: z.string().optional(),
  gender: z.enum(["male", "female"]),
  country: z.string().min(1, "Country is required"),
  state: z.string().min(1, "State is required"),
  lga: z.string().optional(),
  address: z.string().optional(),
  phone: z.string().min(1, "Phone is required"),
  whatsapp_phone: z.string().optional(),
  avatar: z.string().optional(),
  status: z.boolean(),
};

// Schema for creating new users - password is required
export const createUserSchema = z.object({
  ...baseUserSchema,
  password: z.string().min(6, "Password must be at least 6 characters"),
});

// Schema for updating users - password is optional and can be empty
export const updateUserSchema = z.object({
  ...baseUserSchema,
  password: z.string().optional().or(z.literal("")),
});

// Export types
export type CreateUserFormData = z.infer<typeof createUserSchema>;
export type UpdateUserFormData = z.infer<typeof updateUserSchema>;
export type UserFormData = CreateUserFormData | UpdateUserFormData;
